<ng-container *ngIf="sourceLanguage$ | async"></ng-container>
<div class="translation-key">
  <div>
    <label style="padding-right: 10px">{{label||'Translation Key'}}</label>
    <button nbButton ghost *ngIf="hasLoaded" (click)="openUpdateTranslation()">
      Update Translation
    </button>
  </div>
  <div>
    <ng-container *ngIf="!hasLoaded; else selection">
      <span style="padding: 10px; display: flex; justify-content: center"
        ><i class="fas fa-spinner fa-spin"></i
      ></span>
    </ng-container>
    <ng-template #selection>
      <nb-form-field>
        <nb-select
          [(ngModel)]="selectedKey"
          placeholder="Translation Key"
          [fullWidth]="true"
          (selectedChange)="updateValue($event)"
        >
          <nb-option [value]=""> --none-- </nb-option>

          <nb-option *ngFor="let option of options" [value]="option.key">{{
            option.key
          }}</nb-option>
        </nb-select>
      </nb-form-field>
    </ng-template>
  </div>
</div>
